import { render, staticRenderFns } from "./seller-settlement-stat.vue?vue&type=template&id=4223fee4&scoped=true"
import script from "./seller-settlement-stat.vue?vue&type=script&lang=js"
export * from "./seller-settlement-stat.vue?vue&type=script&lang=js"
import style0 from "./seller-settlement-stat.vue?vue&type=style&index=0&id=4223fee4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4223fee4",
  null
  
)

export default component.exports